import anime from "animejs";
import { appUtils, configs } from "..";
import { app } from "../appProduct";
import { TypeDirFactor } from "../data";
import { LangsEvents } from "../data/langs";
import PgProduct from "./pgProduct";
import ProductBase from "./productBase";
import Slider from "./slider";

export default class PgProductItem extends ProductBase {

    private _index: number;
    private _ingredients: HTMLElement;
    private _releateds: any;
    private _slider: Slider;
    private _boxesGlow: NodeListOf<HTMLElement>;

    get index() { return this._index; }

    constructor(index: number) {
        super();

        this._index = index;
        this._data = app.products.data.products[this._index];
        this._catData = app.products.data.categories[this._data.categoryId];

        const lang = app.langs.lang.products[this._data.id.toString()],
            langCat = app.langs.lang.categories[this._data.categoryId];

        this._cont = appUtils.stringToHTML(app.templates["product"]
            .replace(/\{id\}/g, this._data.id.toString())
            .replace(/\{cat-id\}/g, this._data.categoryId)
            .replace("{title}", lang.title)
            .replace("{category}", langCat.title)
            .replace("{subtitle}", lang.subtitle)
            .replace("{summary}", lang.summary)
            .replace("{desc}", lang.desc.replace(/\n/gm, "<br />"))
            .replace("{box-glow-path}", this._data.bg_detail_glow ? `${this._data.categoryId}/${this._data.id}/` : this._data.categoryId)
        );
        this._setBackground(true);

        this._boxesGlow = this._cont.querySelectorAll(".product-detail-box-glow");
        this._boxes = this._cont.querySelectorAll(".product-box");

        this._bgIngredients = this._cont.querySelector(".product-detail-parallax");
        this._fillBgIngredients();

        this._ingredients = this._cont.querySelector(".product-detail-ingredients");
        this._fillIngredients();

        this._releateds = this._cont.querySelector(".product-detail-related .product-list");
        this._fillReleateds();

        this._slider = new Slider(this._cont.querySelector(".product-detail-related"),
            //this._cont.querySelector(".btn-releated-next"),
            //this._cont.querySelector(".btn-releated-prev")
        );
        this._addParallax(app);

        this._cont.style.display = "none";
        app.ui.cont.appendChild(this._cont);
        app.langs.on(LangsEvents.Changed, this._onLangChange.bind(this));
    }

    private _fillIngredients() {
        this._data.ingredients.forEach(item => {
            const elm = appUtils.stringToHTML(app.templates["ingredient"]
                .replace(/{id}/g, item.id)
                .replace("{title}", app.langs.lang.ingredients[item.id].title)
            );
            elm.style.setProperty("--borderColor", app.products.data.ingredients[item.id].color);
            elm.style.width = item.percent * 100 + "%";
            this._ingredients.appendChild(elm);
        });
    }

    private _fillReleateds() {
        this._data.releateds.forEach((item, index) => {
            if (index > 4)
                return;

            const product = app.products.data.products.find(pitem => pitem.id == item);
            if (!product) {
                console.error("releated not found!", item);
                return;
            }
            const elm = appUtils.stringToHTML(app.templates["releated"]
                .replace(/{id}/g, product.id.toString())
                .replace(/{cat-id}/g, product.categoryId)
                .replace("{title}", app.langs.lang.products[item].title)
            );
            elm.querySelector<HTMLAnchorElement>("a").addEventListener("click", () => app.ui.show(app.ui.getIndexById(item), 1));
            this._releateds.appendChild(elm);
        });
    }

    override _onLangChange() {
        this._cont.querySelectorAll<HTMLElement>("[data-lang-text]").forEach(item => {
            switch (item.dataset["langText"]) {
                case "category":
                    item.textContent = app.langs.lang.categories[this._data.categoryId].title;
                    break;
                case "ingredient":
                    item.textContent = app.langs.lang.ingredients[item.dataset["id"]].title;
                    break;
                case "releated":
                    item.textContent = app.langs.lang.products[item.dataset["id"]].title;
                    break;
                default:
                    item.textContent = app.langs.lang.products[this._data.id][item.dataset["langText"]];
                    break;
            }
        });
    }

    override show(dirFactor: TypeDirFactor) {
        super.show(dirFactor);

        if (dirFactor == 0)
            app.ui.setHeight(dirFactor);

        anime({
            targets: this._boxesGlow,
            opacity: [0, 1], delay: 100,
            duration: configs.animDurPageChange, easing: "linear"
        });
    }

    override _onShowDone() {
        super._onShowDone();
        app.ui.setHeight(0);
    }

    override hide(dirFactor: TypeDirFactor) {
        super.hide(dirFactor);

        anime({
            targets: this._boxesGlow,
            opacity: 0, duration: configs.animDurPageChange * .9, easing: "linear"
        });
    }

    override _onHideDone() {
        this._animating = false;
        app.ui.cont.removeChild(this._cont);
    }
}